import { FC, memo } from 'react'

import { Link } from '~/components/Link'
import { TopicOverview } from '~/types/theory'
import { getTopicClassName } from '~/encyclopedia/utils/encyclopedia.utils'

import { SubjectButton } from './SubjectButton'

interface SubChapterProps {
  topic: TopicOverview
  isSelectedTopic: (topic: TopicOverview) => boolean
  findNextUrl: (topic: TopicOverview) => string
}

function getTopicChildren(topic: TopicOverview): TopicOverview[] {
  if ('children' in topic && topic.children) return topic.children
  return []
}

const SubChapterComponent: FC<SubChapterProps> = ({ topic, isSelectedTopic, findNextUrl }) => {
  const isSelected = isSelectedTopic(topic)
  const subChapterHeight = isSelected ? 'max-h-fit-content xl:max-h-96' : 'max-h-0'
  return (
    <div className="leading-10">
      <Link
        className={
          'p-1 pl-2 rounded-small text-left text-sm ' +
          `${isSelected ? getTopicClassName(topic, 'only-text') : 'text-gray-link'}`
        }
        to={findNextUrl(topic)}
      >
        {topic.h1}
      </Link>

      {topic.shouldRenderChildren && (
        <div className={`flex flex-col ml-4 ${subChapterHeight} transition-all duration-500 ease-in-out `}>
          {getTopicChildren(topic).map((subTopic) => (
            <SubjectButton
              findNextUrl={findNextUrl}
              isSelectedTopic={isSelectedTopic}
              key={subTopic.path}
              show={isSelected}
              topic={subTopic}
            />
          ))}
        </div>
      )}
    </div>
  )
}
export const SubChapter = memo(SubChapterComponent)
